import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import {
    devConfig, // Importing development configuration
    gamesCasino, // Importing casino games configuration
    profile, // Importing user profile configuration
    providersCasino, // Importing casino providers configuration
} from 'config/config'; // Importing configurations from config file

/**
 * Class representing the view for partner products table.
 * @extends JetView
 */
export default class tablePartnersProductsView extends JetView {
    /**
     * Configures the view layout.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        var data = []; // Initialize data array
        return {
            rows: [
                {
                    view: 'dataview', // Data view component
                    id: 'dataview1', // Unique ID for the data view
                    css: 'myBackground', // CSS class for styling
                    template: function (obj) {
                        // Template function for rendering items
                        var width = 200 * parseInt(obj.column); // Calculate width based on column
                        var height = 120 * parseInt(obj.row); // Calculate height based on row
                        return (
                            `<div class="container w-` +
                            obj.column +
                            ` h-` +
                            obj.row +
                            `">
                               <img src="` +
                            obj.icon +
                            `"  width="` +
                            width +
                            `" height="` +
                            height +
                            `">
                              <div class="top-left">` +
                            obj.name +
                            `</div>
                             </div>`
                        ); // Return HTML structure for each item
                    },
                    scroll: 'y', // Enable vertical scrolling
                    autoheight: false, // Disable auto height adjustment
                    drag: true, // Enable dragging of items
                    type: {
                        width: 'auto', // Set width type
                        height: 'auto', // Set height type
                        css: 'myDataview', // CSS class for data view items
                    },
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const _ = this.app.getService('locale')._; // Localization service
        const id_partner = this.getParam('partner', true); // Get partner ID from parameters
        // Adding custom styles for the data view
        webix.html.addStyle(
            '\n' +
                '.myBackground .webix_scroll_cont .myDataview {\n' +
                '    grid-column: span 1;\n' +
                '    grid-row: span 1;\n' +
                '    width: 100%!important;\n' +
                '    height: 100%!important;\n' +
                '}\n' +
                '\n' +
                '.myBackground .webix_scroll_cont .myDataview {\n' +
                '    grid-column: span 1;\n' +
                '    grid-row: span 1;\n' +
                '    width: 100%!important;\n' +
                '    height: 100%!important;\n' +
                '}\n' +
                '\n' +
                '\n' +
                '.myBackground .webix_scroll_cont .myDataview.h-2 {\n' +
                '    grid-column: span 2;\n' +
                '    grid-row: span 2;\n' +
                '    width: 100%!important;\n' +
                '    height: 100%!important;\n' +
                '}\n' +
                '\n' +
                '.myBackground .webix_scroll_cont .myDataview.w-2 {\n' +
                '    grid-column: span 2;\n' +
                '    grid-row: span 2;\n' +
                '    width: 100%!important;\n' +
                '    height: 100%!important;\n' +
                '}\n' +
                '\n' +
                '\n' +
                '\n' +
                '.webix_dataview_item.myDataview img {\n' +
                '    width: 100%;\n' +
                '}\n' +
                '\n' +
                '.myBackground .webix_scroll_cont {\n' +
                '    display: grid!important;\n' +
                '    grid-template-columns: repeat(auto-fill,minmax(180px,1fr));\n' +
                '    grid-gap: 16px;\n' +
                '    grid-auto-rows: minmax(129px,auto);\n' +
                '    grid-auto-flow: dense;\n' +
                '}',
        );
        var categorie = ''; // Initialize category variable
        var country = ''; // Initialize country variable
        var string1 = ''; // Initialize query string variable
        // Event listener for filtering partner products
        this.on(this.app, 'partnerProducts:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            string1 = ''; // Reset query string
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Categorie') {
                        categorie = object[i][1]; // Set category from filter data
                    }
                    if (object[i][0] == 'CountrySelect') {
                        country = object[i][1]; // Set country from filter data
                    }
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to query string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to query string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to query string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]); // Create date object for start date
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Add start date to query string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]); // Create date object for end date
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Add end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            $$('dataview1').clearAll(); // Clear existing data in the data view
            $$('dataview1').load(
                devConfig.geturlApi() + 'PartnersGames/GetOrderPartnersGames?Partner=' + id_partner + string1, // Load new data based on filters
                function (text, data, http_request) {
                    setTimeout(() => {
                        $('.h-2').closest('.myDataview').addClass('h-2'); // Add height class to items
                        $('.w-2').closest('.myDataview').addClass('w-2'); // Add width class to items
                    }, 100);
                },
            );
            setTimeout(() => {
                $('.h-2').closest('.myDataview').addClass('h-2'); // Add height class to items
                $('.w-2').closest('.myDataview').addClass('w-2'); // Add width class to items
            }, 100);
        });
        // Event listener for drag-and-drop functionality
        $$('dataview1').attachEvent('onBeforeDrop', function (context, ev) {
            webix
                .ui({
                    view: 'window', // Create a confirmation window
                    head: {
                        view: 'toolbar',
                        cols: [
                            {
                                view: 'label',
                                label: _('Desea realizar movimiento?'), // Confirmation message
                            },
                        ],
                    },
                    position: 'center', // Center the window
                    modal: true, // Make the window modal
                    body: {
                        view: 'form', // Form inside the window
                        id: 'form', // Unique ID for the form
                        elements: [
                            {
                                view: 'text', // Text input for observation
                                label: _('Observación'),
                                name: 'Note',
                                required: false, // Not required
                                labelWidth: 100, // Label width
                            },
                            {
                                cols: [
                                    {
                                        view: 'button', // Cancel button
                                        value: _('Cancelar'),
                                        click: function () {
                                            this.getTopParentView().hide(); // Hide the window
                                            $$('dataview1').clearAll(); // Clear data view
                                            $$('dataview1').load(
                                                devConfig.geturlApi() +
                                                    'PartnersGames/GetOrderPartnersGames?Partner=' +
                                                    id_partner +
                                                    string1, // Reload data
                                                function (text, data, http_request) {
                                                    setTimeout(() => {
                                                        $('.h-2').closest('.myDataview').addClass('h-2'); // Add height class to items
                                                        $('.w-2').closest('.myDataview').addClass('w-2'); // Add width class to items
                                                    }, 100);
                                                    setTimeout(() => {
                                                        $('.h-2').closest('.myDataview').addClass('h-2'); // Add height class to items
                                                        $('.w-2').closest('.myDataview').addClass('w-2'); // Add width class to items
                                                    }, 100);
                                                },
                                            );
                                        },
                                    },
                                    {
                                        view: 'button', // Save button
                                        type: 'form',
                                        value: _('Guardar'),
                                        click: function ($e) {
                                            this.getTopParentView().hide(); // Hide the window
                                            var valuesForm = $$('form').getValues(); // Get form values
                                            if ($$('form').validate()) {
                                                // Validate form
                                                var vthis = this; // Reference to the current instance
                                                webix.delay(
                                                    function () {
                                                        var orderPartnersGames = context.from.data.order; // Get order data
                                                        webix
                                                            .ajax()
                                                            .headers({
                                                                'Content-type': 'application/json', // Set content type
                                                            })
                                                            .post(
                                                                devConfig.geturlApi() +
                                                                    'PartnersGames/SaveOrderPartnersGames', // API endpoint
                                                                '{"Partner":"' +
                                                                    id_partner +
                                                                    '","OrderPartnersGames":"' +
                                                                    orderPartnersGames +
                                                                    '", "Categorie":"' +
                                                                    categorie +
                                                                    '","Note":"' +
                                                                    valuesForm.Note +
                                                                    '","CountrySelect":"' +
                                                                    country +
                                                                    '","TypeDevice":"' +
                                                                    $$('TypeDevice').getValue() +
                                                                    '"}', // JSON payload
                                                                {
                                                                    error: function (text, data, XmlHttpRequest) {
                                                                        webix.message(
                                                                            _('Error! '), // Error message
                                                                        );
                                                                        vthis.getTopParentView().hide(); // Hide the window
                                                                    },
                                                                    success: function (text, data, XmlHttpRequest) {
                                                                        var data = JSON.parse(
                                                                            text, // Parse response
                                                                        );
                                                                        if (!data.HasError) {
                                                                            webix.message(
                                                                                _(
                                                                                    'Juego Ordenado', // Success message
                                                                                ),
                                                                            );
                                                                        } else {
                                                                            webix.message(
                                                                                _(
                                                                                    'Error! ', // Error message
                                                                                ),
                                                                            );
                                                                        }
                                                                        vthis.getTopParentView().hide(); // Hide the window
                                                                    },
                                                                },
                                                            );
                                                    },
                                                    '',
                                                    '',
                                                    1000, // Delay before execution
                                                );
                                            } else {
                                                webix.message({
                                                    title: _('¡Error!'), // Error title
                                                    type: 'alert-error', // Error type
                                                    text: _(
                                                        'Completa los campos...', // Error message
                                                    ),
                                                });
                                            }
                                        },
                                    },
                                ],
                            },
                        ],
                        elementsConfig: {
                            on: {
                                onChange: function () {
                                    this.validate(); // Validate form on change
                                },
                            },
                        },
                    },
                })
                .show(); // Show the confirmation window
        });
    }
}

// FILE DOCUMENTED
